import {
  Box,
  Button,
  CardHeaderActions,
  Separator,
  Tooltip,
} from "@prismicio/editor-ui"

import { type CropperImage } from "../../../core/imageUtils"
import { type CroppedImages, CropperDialog } from "../CropperDialog"
import { ImageFieldTitle } from "./ImageFieldTitle"

interface ImageFieldHeaderProps {
  fieldLabel: string
  imageLabel: string[]
  initialImages: CropperImage[]
  page: number
  displaySeparator?: boolean
  isSVGContentView: boolean
  visibility: "visible" | "hidden"
  onClear: () => void
  onCropperDialogClose: (result: {
    croppedImages: CroppedImages
    option: number
  }) => void
  onMediaDialogOpenChange: (open: boolean) => void
}

export function ImageFieldHeader(props: ImageFieldHeaderProps) {
  const {
    fieldLabel,
    imageLabel,
    initialImages,
    page,
    displaySeparator = true,
    isSVGContentView,
    visibility,
    onClear,
    onCropperDialogClose,
    onMediaDialogOpenChange,
  } = props

  return (
    <Box display="flex" flexDirection="column" gap={12}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={4}
      >
        <ImageFieldTitle fieldLabel={fieldLabel} imageLabel={imageLabel} />
        <CardHeaderActions sx={{ visibility }}>
          <CropperDialog
            trigger={
              <Button
                startIcon="crop"
                disabled={isSVGContentView}
                hiddenLabel="Crop & Resize"
              />
            }
            renderTooltip={(trigger) => (
              <Tooltip content="Crop & Resize">{trigger}</Tooltip>
            )}
            initialImages={initialImages}
            initialOption={page}
            onClose={onCropperDialogClose}
          />
          <Tooltip content="Replace">
            <Button
              startIcon="imageSearch"
              hiddenLabel="Replace"
              onClick={() => onMediaDialogOpenChange(true)}
            />
          </Tooltip>

          <Tooltip content="Clear">
            <Button onClick={onClear} startIcon="delete" hiddenLabel="Clear" />
          </Tooltip>
        </CardHeaderActions>
      </Box>
      {displaySeparator && <Separator style="dashed" decorative />}
    </Box>
  )
}
